import { MimeTypesByExtension } from 'shared/domains/filesystem/utils/fileExtensions';
export const isPdf = (file) => file.type === MimeTypesByExtension.Pdf;
export const isDocx = (file) => file.type === MimeTypesByExtension.Docx;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#description
const UNSUPPORTED_NON_ESCAPED_CHARACTERS = ["'", '!', '~', '*', '(', ')'];
export const filenameRegexp = new RegExp(`[${UNSUPPORTED_NON_ESCAPED_CHARACTERS.join('')}]+`, 'g');
